import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React, { memo } from "react";

const GroupItem = memo(
  ({
    name,
    showLink,
    updatingAllNotifications,
    markAllNotificationsAsRead,
  }) => (
    <div className="py-2 px-3 small text-grey-dark d-flex justify-content-between align-items-center border-bottom bg-grey-lightest">
      {name}
      {showLink &&
        (updatingAllNotifications ? (
          <FontAwesomeIcon
            icon="fa-spinner"
            className="text-secondary"
            size="xs"
            spin
          />
        ) : (
          <a
            type="button"
            className="link text-grey-dark"
            onClick={markAllNotificationsAsRead}
          >
            Mark all as read
          </a>
        ))}
    </div>
  ),
);

GroupItem.propTypes = {
  name: PropTypes.string.isRequired,
  showLink: PropTypes.bool,
  updatingAllNotifications: PropTypes.bool,
  markAllNotificationsAsRead: PropTypes.func.isRequired,
};

export default GroupItem;
